import Footer from "../../components/common/layout/Footer";
import { Breadcrumbs, IntroSection, ReferralForm } from "@/components/features/referAndEarn";
import SEO from "@/components/common/seo/seo";

export default function AiSolutions() {
    return (
        <div>
            <SEO
                title="Refer and Earn Program - SAN micron"
                description="Join SAN micron's Refer and Earn Program! Refer friends and colleagues to our services and earn exciting rewards for every successful referral."
            />
            <Breadcrumbs />
            <IntroSection />
            <ReferralForm />

            <Footer />
        </div>
    );
}